// footer.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private showHeaderFooter = new BehaviorSubject<boolean>(true);
  showHeaderFooter$ = this.showHeaderFooter.asObservable();

  setVisibility(show: boolean) {
    this.showHeaderFooter.next(show);
  }
  
  private showFooterSubject = new BehaviorSubject<boolean>(true);
  showFooter$ = this.showFooterSubject.asObservable();

  private headerVisibility = new BehaviorSubject<boolean>(true);
  headerVisibility$ = this.headerVisibility.asObservable();

  private showWhatsappSubject = new BehaviorSubject<boolean>(true);
  showWhatsapp$ = this.showWhatsappSubject.asObservable();

  private showTidioChatSubject = new BehaviorSubject<boolean>(true);
  showTidioChat$ = this.showTidioChatSubject.asObservable();

  private showWhatsappSource = new BehaviorSubject<boolean>(true);
  showWhatsapp1$ = this.showWhatsappSource.asObservable();

  setShowWhatsapp(value: boolean) {
    this.showWhatsappSource.next(value);
  }

  constructor() {}

  toggleFooterVisibility(show: boolean) {
    this.showFooterSubject.next(show);
  }

  toggleHeaderVisibility(show: boolean) {
    this.headerVisibility.next(show);
  }
  toggleWhatsappVisibility(show: boolean) {
    this.showWhatsappSubject.next(show);
  }

  toggleTidioChatVisibility(show: boolean) {
    this.showTidioChatSubject.next(show);
  }

  showHeader() {
    this.headerVisibility.next(true);
  }

  hideHeader() {
    this.headerVisibility.next(false);
  }
}
